import { useState } from 'react';

import SubmitButton from 'components/ui/buttons/SubmitButton';

import TicketApi from 'api/ticket';
import NotificationHelper from 'helpers/NotificationHelper';
import { useAuth } from 'providers/auth';

const AddCommentForm = ({ id, onAddComment }) => {
  const [saving, setSaving] = useState(false);
  const { me } = useAuth();

  const onSubmit = async e => {
    e.preventDefault();

    const formDataObj = new FormData(e.target);
    const formData = Object.fromEntries(formDataObj);
    setSaving(true);

    try {
      const bind = { description: formData.text, ticket_id: id, created_by: me.id };
      await TicketApi.addComment(bind);

      e.target.reset();
      onAddComment(formData);
    } catch (error) {
      console.error(error);
      NotificationHelper.snack('Falha ao adicionar comentário');
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <form onSubmit={onSubmit}>
        <hr />
        <textarea className="form-control" rows={3} name="text" required disabled={saving}></textarea>

        <div className="text-right mt-2">
          <SubmitButton disabled={saving} tkey="Adicionar Comentário" className="btn btn-primary" loading={saving} />
        </div>
      </form>
    </>
  );
};

export default AddCommentForm;
